import {actionTypes as importNestsWizardActions }from '../../../actions/Wizards/ImportNestsWithRoll/importNestsWithRollWizardActions.js';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import {gridsNames}  from '../../../enums/gridsNames';
import {actionTypes as gridActions} from 'infrastructure/js/components/Grid/Utils/gridActionsHelper.js';
import { Map } from 'immutable';

let defaultState = {
  errors: null,
  nestsErrors: null,
  loading: false,
  validatedFileData: null,
  fileToken: null,
  selectedFile: null,
  importFileData: null,
  selectedAssetType: null,
  parentComponent: null,
  currentDate: DateTimeHelper.DateFormat(Date.now()),
  importTypes: [],
  shouldIncludeLocation: false,
  showPrintLabels: false,
  acceptFileTypes:[],
  rollId: null,
  materialBusinessId: null,
  nestsItems: [],

  // Set only by a failed SAP verification, and it alone decides whether the footer's
  // "continue without SAP verification" checkbox exists. Deliberately separate from
  // nestsErrors, which also carries CSV-parse and length/inspection failures - none of
  // those are the operator's to wave through.
  sapVerificationFailed: false,
  ignoreSapVerification: false
};

// Any change to what is about to be submitted retires the previous verdict, so the override
// retires with it: the operator waived one specific set of barcodes, not the screen in general.
// Checking the box again after the re-run is one click, and it keeps "proceed unverified" an
// answer to a question that was actually asked.
function clearSapVerificationOverride(state) {
  return state.set('sapVerificationFailed', false)
              .set('ignoreSapVerification', false);
}

export default function(state = Map(defaultState), action) {

  switch(action.type) {
    case gridActions.GRID_SELECTED_ROWS_CHANGED:
      if (action.payload.gridName !== gridsNames.IMPORT_NESTS_WITH_ROLL_SELECT_NESTS &&
          action.payload.gridName !== gridsNames.IMPORT_NESTS_WITH_ROLL_SELECT_NESTS_STEP_TWO ){
        return state;
      }
      return clearSapVerificationOverride(state.set('nestsErrors', null));

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_SAVE_START_PARAMETERS:
      return state.set('importTypes', action.payload.importTypes)
                  .set('acceptFileTypes', action.payload.acceptFileTypes)
                  .set('parentComponent', action.payload.parentComponent);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_CLEAR_PARAMETERS:
      return Map(defaultState);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_ON_ROWS_CHANGED:
      return clearSapVerificationOverride(state.set('nestsErrors', null)
                                               .set('nestsItems', action.payload));

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_HAS_ERRORS:
      return state.set('errors', action.payload);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_HAS_SELECTED_NESTS_ERRORS:
      return clearSapVerificationOverride(state.set('nestsErrors', action.payload));

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_SAP_VERIFICATION_FAILED:
      return state.set('sapVerificationFailed', true);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_TOGGLE_IGNORE_SAP_VERIFICATION:
      return state.set('ignoreSapVerification', !!action.payload);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_UPLOAD_FILE_IN_PROGRESS:
      return state.set('loading', true);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_UPLOAD_FILE_FINISHED:
      return clearSapVerificationOverride(state.set('errors', null)
                                               .set('nestsErrors', null)
                                               .set('nestsItems', action.payload.importCutPlanWithRollGroupedByNestModel)
                                               .set('loading', false));

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_UPLOAD_FILE_FAILED:
      return state.set('loading', false);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_VALIDATE_FILE_IN_PROGRESS:
      return state.set('loading', true);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_VALIDATE_FILE_FINISHED:
      return state.set('validatedFileData', action.payload.data)
                  .set('fileToken', action.payload.token)
                  .set('validationJobId', action.payload.validationJobId)
                  .set('loading', false);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_VALIDATE_FILE_FAILED:
      return state.set('loading', false);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_IMPORT_FILE_IN_PROGRESS:
      return state.set('loading', true);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_IMPORT_FILE_FINISHED:
      return state.set('importFileData', action.payload)
                  .set('selectedFile', null)
                  .set('loading', false);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_IMPORT_FILE_FAILED:
      return state.set('errors', action.payload)
                  .set('loading', false);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_SELECTED_ASSET_TYPE_CHANGED:
      return state.set('selectedAssetType', action.payload);

    case importNestsWizardActions.IMPORT_NESTS_WITH_ROLL_SELECTED_FILE_CHANGED:
      return state.set('selectedFile', action.payload);

    default:
      return state;
  }

  return state;
}
